import { render, staticRenderFns } from "./TrialFinishedModal.vue?vue&type=template&id=38bc9a98&scoped=true"
import script from "./TrialFinishedModal.vue?vue&type=script&lang=js"
export * from "./TrialFinishedModal.vue?vue&type=script&lang=js"
import style0 from "./TrialFinishedModal.vue?vue&type=style&index=0&id=38bc9a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc9a98",
  null
  
)

export default component.exports